import React from 'react';
import CreateAiPersona from '../../components/CreateAiPersona/CreateAiPersona';

const CreateAiPersonaPage = () => {
    return (
        <CreateAiPersona />
    );
};

export default CreateAiPersonaPage;